const PAYMENT_STATUS = {
	IN_DUE: 0,
	PAID: 1,
	OVERPAID: 2,
	TO_REFUND: 3,
	FULLY_REFUNDED: 4,
}

export { PAYMENT_STATUS }
export default PAYMENT_STATUS




// WEBPACK FOOTER //
// ./src/enums/paymentStatus.js